import {INormalize, Partner, Period, RRDate} from "@raskrask-dk/raskrask-utils";
import type {IAllPartnerResponseDTO, IPartnerDTO, IPeriodDTO} from "..";
import type {IdValTuple, MapById} from "./mapper.types";

export class PartnerMapper {
  constructor(private partnerConstructor: (partnerDTO: IPartnerDTO) => Partner) {}

  fromIPeriodToSchedule(dto: IPeriodDTO): Period {
    const formatExpected = "yyyy-MM-dd HH:mm:ss";
    if (dto.format !== formatExpected)
      throw new Error(`Date format (${dto.format}) not matching ${formatExpected}. Can't construct partner. ${JSON.stringify(dto)}`);
    const from = new RRDate(dto.from, formatExpected);
    const to = new RRDate(dto.to, formatExpected);
    return new Period(from, to);
  }

  fromDTO(dto: IPartnerDTO): Partner {
    const periods = dto.schedules.map((schedule) => this.fromIPeriodToSchedule(schedule));
    const partner = this.partnerConstructor(dto);
    partner.schedule.addPeriods(periods);
    return partner;
  }

  fromAllPartnerResponseDTO(dto: IAllPartnerResponseDTO): Partner {
    const partner = this.fromDTO(dto);
    partner.birdDistance = dto.birdDistanceToCustomer;
    return partner;
  }

  fromDtoToTuple(dto: IPartnerDTO): IdValTuple<Partner> {
    return [dto.id, this.fromDTO(dto)];
  }

  fromNormalized(partners: INormalize<IPartnerDTO>): MapById<Partner> {
    return new Map(partners.allIds.map((id) => [parseInt(id), this.fromDTO(partners.byId[id])]));
  }
}
